import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class UnitDeliveredTrans extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);


		this.state = {

			start_date 	: "",
			end_date 	: "",
			component_type:"all",
			components:[],
			blood_component_id:"all",
			blood_components:[],
			destination:"all",
			destinations:[],
			type:"all",
			types:[],
			listado:[],
			listado_pdf:[],
			columns:[
				{title:'Hospital'},
				{title:'Folio'},
				{title:'F. Envio'},
				{title:'Componente'},
				{title:'No. Unidad'},
				{title:'Volumen'},
				{title:'Grupo & RH'},
				{title:'Paciente'},
				{title:'Usuario'},
				{title:'Turno'},
				{title:'Devuelta'}
			],
			filename:"Unidades Enviadas Transfundir",
			format:'',
			totales:{
				total_patients:'0',
				total_units:'0'
			},

			component_name:"",
			blood_component_name:"",
			destination_name:"",
			type_name:"",
			date_hour:"",
			medical:"",
			work_session: "all",
			sessions: [],
			option: "all"
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}


	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({components:response});
			}
		})

		fetch(Config.default.apiGateway.URL+'national_centers/expenses', {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({destinations:response});
			}
		})

		fetch(Config.default.apiGateway.URL+'work_sessions/actives?health_facilities_id='
			+sessionStorage.getItem('health_facilities_id'), {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({sessions:response});
			}
		})

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getBloodComponent(){
		fetch(Config.default.apiGateway.URL+'blood_component/by_type?type='+this.state.component_type, {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({blood_components:response});
			}
		})
	}

	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 
		
		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdfHtml5',
					title: this.state.filename,
					orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas+'\t\t\t'+this.state.medical, margin:[10,0,0,10] });
						doc.content.splice(3, 0, {
							columns:[
								this.state.component_type !== "all" && this.state.component_type !== "" ?
									{text: 'Tipo Componente', width:'10%', fontSize:6.5}
								: {text:"", width:0},
								this.state.component_type !== "all" && this.state.component_type !== "" ?
									{text: this.state.component_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.blood_component_id !== "all" && this.state.blood_component_id !== "" ?
									{text: 'Componente', width:'8%', fontSize:6.5}
								: {text:"", width:0},
								this.state.blood_component_id !== "all" && this.state.blood_component_id !== "" ?
									{text: this.state.blood_component_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.destination !== "all" && this.state.destination !== "" ?
									{text: 'Destino', width:'5%', fontSize:6.5}
								: {text:"", width:0},
								this.state.destination !== "all" && this.state.destination !== "" ?
									{text: this.state.destination_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.type !== "all" && this.state.type !== "" ?
									{text: this.state.type_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},
							]
						});

						doc.content.splice(4, 0, {text: 'Pacientes Transfundidos: '+this.state.totales.total_patients, margin:[10,0,0,10]});
						doc.content.splice(5, 0, {text: 'Unidades enviadas: '+this.state.totales.total_units, margin:[10,0,0,10]});

						var head = []
						this.state.columns.map((c, i)=>{
							if(i > 0){
								head.push({text:c.title, style:'tableHeader'})
							}
							
						})

						this.state.listado_pdf.unshift(head);

                		doc.content[6].table.body = this.state.listado_pdf;
                		if(this.state.format === 'general'){
							doc.content[6].table.widths=["5%", "8%","8%","5%","5%","5%","15%","8%", "8%","15%", "5%", '5%', '8%'];
						}else{
							doc.content[6].table.widths=["10%","12%","5%","5%","5%","12%","10%", "10%", "12%", "5%", '5%', '9%'];
						}
						
						

                		/*doc.content[5] = {
							text:'Total: '+this.state.totales,
							margin:[5,15,0,0]
            			}*/
                		doc.styles.tableHeader.fontSize = 6;
                		doc.defaultStyle.fontSize = 6; //2,3,4,etc doc.styles.tableHeader.fontSize = 1; //2, 3, 4, etc 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};

                	} 
            	},
            ],
            rowGroup: {
	            dataSrc: [ 0 ],
	            startRender: function ( rows, group ) {
	            	var head = rows.data().pluck(0)[0];
	            	var len = rows.data()[0].length-1

	            	return head !== ""  && group !== ""?
	            		$('<tr/>').append( '<td colspan="'+len+'">'+
	            			(group.indexOf('$') !== -1 ?
	            				group.split('$')[0]
	            			: group)+
	            		'</td>' )
	            	:$('<tr/>');
	            },
	            endRender: function ( rows, group ) {
	              	var len = rows.data()[0].length-1
	                return  $('<tr/>').append( 
	                	'<td colspan="'+len+'" style="background:none;">'+
	                		'Total de unidades en el folio : '+rows.count()+
	                		(group.indexOf('$') !== -1 ?
	            				'\t\t - '+group.split('$')[1]
	            			: '')+
	                	'</td>' );
	            },
	        },
	        columnDefs: [ {
	            targets: [ 0 ],
	            visible: false
	        } ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
					"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

		if(e.target.name === 'component_type'){
			if(e.target.value === 'all'){
				this.setState({blood_component_id:'all'});
			}else{
				this.setState({
					component_name: e.target.options[e.target.selectedIndex].text
				});
				setTimeout(()=>{
					this.getBloodComponent();
				}, 500);
				
			}
		}else if(e.target.name === 'blood_component_id'){
			this.setState({
				blood_component_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'destination'){
			this.setState({
				destination_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'type'){
			this.setState({
				type_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'work_session'){
			this.setState({
				work_session_name: e.target.options[e.target.selectedIndex].text
			})
		}

	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					component_type:this.state.component_type,
					//option:this.state.type,
					national_center_id:this.state.destination,
					blood_component_id: this.state.blood_component_id,
					format: this.state.format,
					health_facilities_id:sessionStorage.getItem('health_facilities_id'),
					work_sessions_id: this.state.work_session,
					option: this.state.option
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/unit_delivered_trans',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						var list = [];
						var list_pdf = [];
						var folio = "";
						var count = 0;
						this.setState({
							listado: [],
						});
						
						if(this.state.format === 'general'){
							this.setState({
								columns:[
									{title:'Hospital', width:'100px'},
									{title:'Folio', width:'90px'},
									{title:'F. Envio', width:'90px'},
									{title:'Componente', width:'120px'},
									{title:'No. Unidad', width:'100px'},
									{title:'Volumen', width:'90px'},
									{title:'Grupo & RH', width:'120px'},
									{title:'Paciente', width:'250px'},
									{title:'Cama', width:'100px'},
									{title:'Servicio', width:'150px'},
									{title:'Usuario', width:'250px'},
									{title:'Turno', width:'120px'},
									{title:'Devuelta', width:'100px'},
									{title:'Unidades de origen', width:'300px'}
								]
							})
						}else{
							this.setState({
								columns:[
									{title:'Folio', width:'90px'},
									{title:'F. Envio', width:'90px'},
									{title:'Componente', width:'120px'},
									{title:'No. Unidad', width:'100px'},
									{title:'Volumen', width:'90px'},
									{title:'Grupo & RH', width:'120px'},
									{title:'Paciente', width:'250px'},
									{title:'Cama', width:'100px'},
									{title:'Servicio', width:'150px'},
									{title:'Usuario', width:'250px'},
									{title:'Turno', width:'120px'},
									{title:'Devuelta', width:'100px'},
									{title:'Unidades de origen', width:'300px'}
								]
							})
						}


						
						response.resp.map((r, i)=>{
							
							var obj_pdf = [];

							if(this.state.format === 'general'){
								obj_pdf.push({text:r.center, colSpan:13,bold:1,fillColor:'#dfdfdf'})
								list_pdf.push(obj_pdf);
							}

							var folio = '';
							r.units.map((u)=>{
								var obj = [];
								obj_pdf = [];
								var index = list_pdf.findIndex(obj => 	
									obj.length === 1 ?
										obj[0].text === (r.folio+'\t '+moment(r.send_date).format('DD/MM/YYYY HH:mm')+'\t '+u.center)
									:null								
								);

								if(index === -1){
									if(this.state.format !== 'general'){
										obj_pdf.push({text:r.folio+'\t '+moment(r.send_date).format('DD/MM/YYYY HH:mm')+'\t '+u.center, colSpan:12,bold:1,fillColor:'#dfdfdf'})
										list_pdf.push(obj_pdf);
									}
								}
									
								obj = [];
								obj_pdf = [];

								var parts = '';
								u.unit_parts.map((part, i)=>
									parts += part+(i === u.unit_parts.length - 1 ? '' : ',\n ')
								)


								if(this.state.format === 'general'){
									obj.push(
										r.center,
										u.folio,
										moment(u.send_date).format('DD/MM/YYYY HH:mm'),
										u.component,
										u.unit_number,
										u.volume,
										u.group_rh,
										u.patient,
										u.ubication,
										u.service,
										u.send_by,
										u.session,
										u.returned,
										parts
									);

									
									
									obj_pdf.push(										
										{text:u.folio, alignment: 'center'},
										{text:moment(u.send_date).format('DD/MM/YYYY HH:mm'), alignment: 'center'},
										{text:u.component},
										{text:u.unit_number, alignment: 'center'},
										{text:u.volume, alignment: 'center'},
										{text:u.group_rh, alignment: 'center'},
										{text:u.patient},
										{text:u.ubication},
										{text:u.service},
										{text:u.send_by},
										{text:u.session},
										{text:u.returned},
										{text:parts}
									);
								}else{
									obj.push(
										r.folio+'\t '+moment(u.send_date).format('DD/MM/YYYY HH:mm')+'\t '+u.center+'\t $'+u.send_by,
										moment(u.send_date).format('DD/MM/YYYY HH:mm'),
										u.component,
										u.unit_number,
										u.volume,
										u.group_rh,
										u.patient,
										u.ubication,
										u.service,
										u.send_by,
										u.session,
										u.returned,
										parts
									)

									
									obj_pdf.push(							
										{text:moment(u.send_date).format('DD/MM/YYYY HH:mm'), alignment:'center'},
										{text:u.component},
										{text:u.unit_number, alignment:'center'},
										{text:u.volume, alignment:'center'},
										{text:u.group_rh, alignment:'center'},
										{text:u.patient},
										{text:u.ubication},
										{text:u.service},
										{text:u.send_by},
										{text:u.session},
										{text:u.returned},
										{text:parts}
									);

								}

								list.push(obj);
								list_pdf.push(obj_pdf);
							})

							/*obj_pdf = [];
							obj_pdf.push({
								text:'Total de Unidades en el Folio '+r.units.length+
										(this.state.format === 'general' ? '' : '\t - '+r.send_by), 
								colSpan:this.state.format === 'general' ? 10 : 7,
								bold:1, 
								margin:[20,0,0,0]});

							
							
							list_pdf.push(obj_pdf);*/

						
						});

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);

						this.setState({
							listado: list,
							listado_pdf:list_pdf,
							totales:response.totales
						});
						
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Distribución ->
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_patients"} 
	                submenu={"help_transfusion_units"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
							
								<div className="form-group">
									<span className="span-min">Tipo de Componente</span>
									<select type="text" name="component_type" id="component_type" 
										value={this.state.component_type} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.components.map((h, i)=>{
											return <option key={i} value={h.key}>
												{h.name}
											</option>
										})}
									</select>
								</div>

								{this.state.component_type !== 'all' ?
									<div className="form-group">
										<span className="span-min">Componente</span>
										<select type="text" name="blood_component_id" id="blood_component_id" 
											value={this.state.blood_component_id} onChange={this.handleChange}
											className="form-control" required>
											<option value="">Seleccione...</option>
											<option value="all">TODOS</option>
											{this.state.blood_components.map((h, i)=>{
												return <option key={i} value={h.id}>
													{h.component}
												</option>
											})}
										</select>
									</div>
								: null}

								<div className="form-group">
									<span className="span-min">Destino</span>
									<select className="form-control" name="destination" id="destination"
										value={this.state.destination} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.destinations.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Turno</span>
									<select type="text" name="work_session" id="work_session" 
										value={this.state.work_session} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.sessions.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.value}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Formato</span>
									<select className="form-control" name="format" id="format" 
										value={this.state.format} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="general">GENERAL</option>
										<option value="by_folio">FOLIO</option>
										
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Unidades Devueltas</span>
									<select className="form-control" name="option" id="option" 
										value={this.state.option} onChange={this.handleChange} required>
										<option value="all">TODO</option>
										<option value="no_dev">SIN DEVOLUCIONES</option>
										<option value="just_dev">SOLO DEVOLUCIONES</option>
										
									</select>
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
									<span>
										{this.state.filename}
									</span>
								</div>
								<div className="col-xs-12 form-group" >
									<span>
										Información Del:  {this.state.start_date !== "" ?
											moment(this.state.start_date).format("DD/MM/YYYY")
										: ''}    
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ?
											moment(this.state.end_date).format("DD/MM/YYYY")
										: ''}
									</span>
								</div>
								<div className="col-xs-12 form-group">
									<div><label>Pacientes Transfundidos: </label> <span>{this.state.totales.total_patients}</span></div>
									<div><label>Unidades enviadas: </label> <span>{this.state.totales.total_units}</span></div>
								</div>

								<div className="col-xs-12" style={{fontSize:'11px'}}>
									{this.state.component_type !== 'all' && this.state.component_type !== ""?
										<span>
											Tipo Componente:  
											<b style={{marginLeft:"5px"}}>{this.state.component_name}</b>
										</span>	
									:null}
									{this.state.blood_component_id !== 'all' && this.state.blood_component_id !== ""?
										<span style={{marginLeft:"10px"}}> 
											Componente:  
											<b style={{marginLeft:"5px"}}>{this.state.blood_component_name}</b>
										</span>	
									:null}
									{this.state.destination !== 'all' && this.state.destination !== ""?
										<span style={{marginLeft:"10px"}}> 
											Destino:  
											<b style={{marginLeft:"5px"}}>{this.state.destination_name}</b>
										</span>	
									:null}
									{this.state.type  !== "all" && this.state.type !== ""?
										<span style={{marginLeft:"15px"}}>
											Tipo: 
											<b style={{marginLeft:"5px"}}>
												{this.state.type_name}
											</b>
										</span>
									:null}
								</div>

								<div className="col-xs-12" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="table-to-xls" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								{/*<div className="col-xs-12 form-group" style={{fontSize:"14px"}}>
									<span className="span-min">Total: </span>{' '+this.state.totales}
								</div>}*/}
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (UnitDeliveredTrans);